interface Shop {
  id: number;
  name: string;
  location: string;
  address: string;
  services: string[];
  rating: number;
  reviewCount: number;
  image: string;
  specialty: string;
}

interface SelectedShopInfoProps {
  shop: Shop;
}

export default function SelectedShopInfo({ shop }: SelectedShopInfoProps) {
  const serviceNames: { [key: string]: string } = {
    nail: '네일',
    eyelash: '속눈썹',
    waxing: '왁싱',
    skincare: '피부관리',
    hair: '헤어',
    makeup: '메이크업'
  };

  return (
    <div className="mb-12">
      <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-3xl p-6 shadow-lg">
        <div className="flex items-center space-x-2 mb-4">
          <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-r from-rose-400 to-pink-400 rounded-full">
            <i className="ri-store-2-fill text-white text-sm"></i>
          </div>
          <h2 className="text-lg font-medium text-gray-800">선택된 매장</h2>
        </div>

        <div className="bg-white rounded-2xl overflow-hidden">
          <div className="flex flex-col md:flex-row">
            <div className="relative w-full md:w-64 h-48">
              <img
                src={shop.image}
                alt={shop.name}
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="flex-1 p-6">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h3 className="text-2xl font-medium text-gray-800 mb-2">{shop.name}</h3>
                  <div className="flex items-center space-x-2 mb-2">
                    <i className="ri-map-pin-line text-gray-500 text-sm"></i>
                    <span className="text-sm text-gray-600">{shop.location}</span>
                  </div>
                  <p className="text-sm text-gray-500">{shop.address}</p>
                </div>
                <div className="flex items-center space-x-1">
                  <i className="ri-star-fill text-yellow-400 text-xl"></i>
                  <span className="text-lg font-medium text-gray-800">{shop.rating}</span>
                  <span className="text-sm text-gray-500">({shop.reviewCount})</span>
                </div>
              </div>

              <p className="text-sm text-gray-700 mb-4 leading-relaxed">{shop.specialty}</p>

              <div className="flex items-center space-x-2">
                <span className="text-sm font-medium text-gray-700">제공 서비스:</span>
                {shop.services.map((service) => (
                  <span
                    key={service}
                    className="text-xs font-medium text-rose-400 bg-rose-50 px-3 py-1 rounded-full"
                  >
                    {serviceNames[service]}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
